import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

import { useWeatherTaskAlerts } from '@/stores/weather-task-store';
import { WeatherConflictCard } from './WeatherConflictCard';

export function WeatherAlertsSection() {
  const { conflicts, dismissConflict, acceptSuggestion } = useWeatherTaskAlerts();
  const [collapsed, setCollapsed] = useState(false);

  if (conflicts.length === 0) return null;

  return (
    <section className="flex flex-col gap-3" data-testid="weather-alerts-section">
      {/* Header */}
      <button
        type="button"
        onClick={() => setCollapsed((c) => !c)}
        className="flex items-center justify-between w-full"
        aria-expanded={!collapsed}
        data-testid="weather-alerts-toggle"
      >
        <span className="field-label text-amber-400">
          Weather Alerts
          <span className="ml-2 px-1.5 py-0.5 rounded-full text-body-xs bg-amber-900/40 text-amber-300 border border-amber-700/30">
            {conflicts.length}
          </span>
        </span>
        {collapsed ? (
          <ChevronDown size={14} className="text-[var(--color-text-placeholder)]" />
        ) : (
          <ChevronUp size={14} className="text-[var(--color-text-placeholder)]" />
        )}
      </button>

      {/* Conflict cards */}
      {!collapsed && (
        <div className="flex flex-col gap-3">
          {conflicts.map((conflict) => (
            <WeatherConflictCard
              key={conflict.taskId}
              conflict={conflict}
              onReschedule={(taskId, newDate) => void acceptSuggestion(taskId, newDate)}
              onDismiss={dismissConflict}
            />
          ))}
        </div>
      )}
    </section>
  );
}
